<script>
import { defineComponent } from "vue";
import { useMeta } from 'quasar';
import FavoriteItem from "@/components/customer/favorites/favoriteItem.vue";
import FavoriteAddToListModal from '@/components/customer/favorites/favoriteAddToList.vue';
import Paginator from "@/helpers/paginator";

const metaData = {
  // sets document title
  title: 'Windy City Wire - Favorites',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
  name: "customerFavorites",
  setup() {
    useMeta(metaData);
  },
  data() {
    return {
      search: "",
      current: 1,
      model: "10/page",
      options: ["10/page", "20/page", "50/page", "100/page", "ALL"],
      height: "",
      sort: 0,
      renderComponent: true,
    };
  },
  components: {
      FavoriteItem,
      FavoriteAddToListModal
  },
  computed: {
    items() {
      return this.$store.getters['customer/favorites']
    },
    addToList() {
      return this.$store.getters['customer/addToList'];
    },
    accessToken() {
      return this.$store.getters["auth/accessToken"];
    },
    isProcessingOrder() {
      return this.$store.getters["customer/isProcessingOrder"];
    },
    limit() {
        let limit = 0;
        switch (this.model) {
        case "10/page":
            limit = 10;
            break;
        case "20/page":
            limit = 20;
            break;

        case "30/page":
            limit = 30;
            break;

        case "40/page":
            limit = 40;
            break;

        case "50/page":
            limit = 50;
            break;

        case "100/page":
            limit = 100;
            break;

        case "ALL":
            return items;

        default:
            limit = 0;
            break;
        }

        return limit;
    },
    max() {
        let max = Math.round(this.filteredSearch.length / this.limit);
        return max == 0 ? 1 : max;
    },
    filteredSearch() {
        if (this.search.length>0) {
            var d = [];
            this.items.forEach(i => {
                if (i.itemNumber.includes(this.search.toUpperCase()) || i.description.toUpperCase().includes(this.search.toUpperCase())) {
                    d.push(i);
                }
            })
            return d;
        }
        return this.items
    },
    filteredData() {

        let s = this.filteredSearch;
        if (this.sort==1) {
            s = s.sort((a, b) => (a.itemNumber > b.itemNumber) ? 1 : -1)
        } else if (this.sort==2) {
            s = s.sort((a, b) => (a.itemNumber > b.itemNumber) ? -1 : 1)
        }

        return Paginator.Paginate(s, this.current, this.model)

    },

  },
  methods: {
    fetchFavorites() {
      this.$store.dispatch('customer/getFavorites', this.accessToken)
    },
    forceRerender() {
    // Remove my-component from the DOM
    this.renderComponent = false;

    this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
    });
    }
  },
  watch: {
      current() {
          this.forceRerender();
      }
  },
  mounted() {
    this.fetchFavorites();
  },
});
</script>


<template>
  <div class="q-pa-none">
    <div class="bodyContainer">
      <!-- SEARCH FOR PRODUCTS -->  
      <div class="row">
        <div class="col-12">
          <q-input color="cyan-7" :dense="true" filled v-model="search" label="Search your Favorites" class="q-mt-md">
            <template v-slot:prepend>
              <q-icon name="fas fa-search wcwYellow" />
            </template>
          </q-input>
        </div>
      </div>

      <!-- SORT BUTTON -->
      <div class="row text-center">
        <div class="col-12 q-pa-sm">
          <q-btn class="wcwYellowButton" :unelevated="true" icon="fas fa-sort-alt" label="Sort" @click="[sort==0?sort=1:[sort==1? sort=2 : sort=1]]" />
        </div>
      </div>

      <!-- PAGINATION -->
      <div class="row">
        <div class="col-12 q-pb-sm">
          <q-pagination v-model="current" color="cyan-7" :max=max :max-pages="7" class="q-mt-sm float-left" boundary-numbers />
          <q-select v-model="model" :dense="true" :options="options" label="Page Size" label-color="cyan-6" class="q-ml-xl float-right" />
        </div>
      </div>
    </div>

    <!-- INSTANT ORDER ITEMS --->
    <div style="height: 100%">
        <q-scroll-area ref="scrollTargetRef" v-bind:style="{height: '100vh', maxWidth: '100%', paddingBottom: '50px'}">
          <div class="mobileDiv"></div>
            <q-list bordered style="margin-bottom: 200px" v-if="renderComponent">
                <div v-if="filteredData.length>0 && !visible">
                    <favorite-item v-for="(item, idx) in filteredData" :key="idx" :item=item :token=accessToken> </favorite-item>
                </div>
                <div v-else>
                  <h6 v-if="items.length==0 && !isProcessingOrder" class="text-center">No Favorites Data</h6>
                </div>
            </q-list>
            <!-- <div class="mobileDiv"></div> -->
            <div class="spacerBottom"></div>
        </q-scroll-area>
    </div>

    <!-- ADD TO LIST MODAL -->
    <favorite-add-to-list-modal :accessToken=accessToken></favorite-add-to-list-modal>

    <q-inner-loading
      :showing="isProcessingOrder"
      label="Please wait loading data..."
      label-class="text-cyan-7"
      label-style="font-size: 1.5em"
      color="cyan-7"
    />
  </div>
</template>